/** Server-side geo detection for middleware (Vercel, Cloudflare, CDN headers). */
export function resolveGeoCountryFromRequest(req) {
  const envOverride = process.env.GEO_COUNTRY || process.env.NEXT_PUBLIC_GEO_COUNTRY;
  if (envOverride) return envOverride.toUpperCase();

  const vercelGeo = req.geo?.country;
  if (vercelGeo) return vercelGeo.toUpperCase();

  const headerNames = [
    "cf-ipcountry",
    "x-vercel-ip-country",
    "cloudfront-viewer-country",
    "x-country-code",
    "x-geo-country",
  ];

  for (const name of headerNames) {
    const value = req.headers.get(name);
    if (value && value !== "XX" && value !== "T1") {
      return value.toUpperCase();
    }
  }

  return null;
}

async function fetchCountryCode(url, parse) {
  const response = await fetch(url, {
    signal: AbortSignal.timeout(4000),
  });
  if (!response.ok) return null;
  return parse(response);
}

/** Client-side geo fallback when middleware cannot detect country (e.g. local dev). */
export async function resolveGeoCountryFromClient() {
  try {
    const fromIpapi = await fetchCountryCode(
      "https://ipapi.co/country_code/",
      async (response) => (await response.text()).trim().toUpperCase()
    );
    if (fromIpapi) return fromIpapi;
  } catch {
    // try next source
  }

  try {
    const fromCountryIs = await fetchCountryCode(
      "https://api.country.is/",
      async (response) => {
        const data = await response.json();
        return String(data?.country || "").trim().toUpperCase();
      }
    );
    if (fromCountryIs) return fromCountryIs;
  } catch {
    return null;
  }

  return null;
}

export function isIndiaCountry(code) {
  return code === "IN";
}
